import type { HeaderConfig, PresetId } from 'providers/HeaderProvider';

const TITLE_DEPOSIT = 'PH.DEPOSIT.NAVIGATION.DEPOSIT';
const TITLE_WITHDRAWAL = 'PH.DEPOSIT.NAVIGATION.WITHDRAWAL';
const TITLE_SAVED_CARD = 'PH.NAVIGATION.SAVED_CARD';
const TITLE_PAYMENT_METHODS = 'PH.NAVIGATION.PAYMENT_METHODS.TITLE';

export const DEFAULT_HEADER_CONFIG: HeaderConfig = {
  navIcon: 'close',
  navIconPosition: 'left',
  title: TITLE_PAYMENT_METHODS,
  showCloseRight: false,
  hideNav: false,
  hideNavLeft: true,
};

export const HEADER_PRESETS: Record<PresetId, Partial<HeaderConfig>> = {
  depositMethods: {
    navIcon: 'close',
    title: TITLE_PAYMENT_METHODS,
    showCloseRight: true,
    hideNavLeft: false,
  },
  withdrawalMethods: {
    navIcon: 'close',
    title: 'PH.NAVIGATION.PAYOUT_METHODS.TITLE',
    showCloseRight: true,
    hideNavLeft: false,
  },
  depositForm: {
    navIcon: 'back',
    title: TITLE_DEPOSIT,
    showCloseRight: true,
    hideNavLeft: false,
  },
  withdrawalForm: {
    navIcon: 'back',
    title: TITLE_WITHDRAWAL,
    showCloseRight: true,
    hideNavLeft: false,
  },
  statusPage: {
    navIcon: 'close',
    title: '',
    showCloseRight: true,
    hideNavLeft: false,
  },
  selectCurrency: {
    navIcon: 'back',
    title: 'PH.NAVIGATION.CHOOSE_CURRENCY.TITLE',
    showCloseRight: false,
    hideNavLeft: false,
  },
  selectNetwork: {
    navIcon: 'back',
    title: 'PH.NAVIGATION.SELECT_NETWORK.TITLE',
    showCloseRight: false,
    hideNavLeft: false,
  },
  checkout: {
    navIcon: 'back',
    title: 'PH.NAVIGATION.CARD_DETAILS.TITLE',
    showCloseRight: true,
    hideNavLeft: false,
  },
  cards: {
    navIcon: 'back',
    title: TITLE_SAVED_CARD,
    showCloseRight: false,
    hideNavLeft: false,
  },
  withdrawalCardList: {
    navIcon: 'back',
    title: TITLE_SAVED_CARD,
    showCloseRight: false,
    hideNavLeft: false,
  },
  withdrawalVerifyAccount: {
    navIcon: 'back',
    title: 'PH.NAVIGATION.CARD_VERIFICATION.TITLE',
    showCloseRight: false,
    hideNavLeft: false,
  },
  changeNumber: {
    navIcon: 'back',
    title: 'PH.BUTTON.CHANGE_PHONE_NUMBER',
    showCloseRight: false,
    hideNavLeft: false,
  },
  otp: {
    navIcon: 'back',
    title: 'PH.BUTTON.CONFIRM',
    showCloseRight: false,
    hideNavLeft: false,
  },
  displayForm: {
    navIcon: 'back',
    title: TITLE_DEPOSIT,
    showCloseRight: true,
    hideNavLeft: false,
  },
  betshopDeposit: {
    navIcon: 'back',
    title: TITLE_DEPOSIT,
    showCloseRight: true,
    hideNavLeft: false,
  },
  betshopWithdrawal: {
    navIcon: 'back',
    title: TITLE_WITHDRAWAL,
    showCloseRight: true,
    hideNavLeft: false,
  },
  rejectWithdrawal: {
    navIcon: 'back',
    title: ' ',
    showCloseRight: false,
    hideNavLeft: false,
  },
  content: {
    navIcon: 'back',
    title: '',
    showCloseRight: true,
    hideNavLeft: false,
  },
  selectCountry: {
    navIcon: 'back',
    title: '',
    showCloseRight: false,
    hideNavLeft: false,
  },
};
